<template>
  <div class="personalized-advisors-page personalized-advisors-wrapper bg-white">
    <Head>
      <Title>{{ $messages('services-personalized-advisors.meta.title') }}</Title>
      <Meta name="description" hid="description" :content="$messages(`services-personalized-advisors.meta.description`)" />
      <Meta name="og:image" hid="og:image" :content="ogImage" />
    </Head>

    <BlocksServiceHeroNew
      service="PersonalizedAdvisors"
      :hero="cmsData.hero[0]"
      :breadcrumbs="breadcrumbs"
      @scroll-to-checkout="onCtaHeroClick"
    />

    <BlocksContentBox v-bind="$messages('services-personalized-advisors.we_speak_content_box')">
      <template #visual>
        <BlocksContentBoxIconCanvasAsset :label="$messages('services-personalized-advisors.we_speak_content_box.canvas')" service="advisor" bg-class="bg-coffee" />
      </template>
    </BlocksContentBox>

    <BlocksContentBox v-bind="$messages('services-personalized-advisors.welcome_content_box')" bg-class="bg-bright-yellow">
      <template #visual>
        <BlocksContentBox-full-image-asset src="https://majority.imgix.net/web-assets/personalized-advisors/welcome-to-the-neighborhood.jpg" />
      </template>
    </BlocksContentBox>

    <BlocksUserReviewList />

    <BlocksFaqV2
      v-bind="$messages('faq')"
    />

    <BlocksMiniCheckout ref="checkout" />
  </div>
</template>

<script>
import { optimize } from '@/utils/image-optimization'
import PageMixing from '@/mixins/page-mixin'
import { CMS_SERVICE_HERO_QUERY } from '@/utils/graphql-queries'

export default {
  layout: 'default',
  mixins: [PageMixing('services-personalized-advisors', 'Services - Personalized Advisors', 'services-personalized-advisors.meta.title')],
  async setup () {
    const currentLocale = useLocale() || 'en'

    const datoHelperClient = useDatoHelper()

    const query = `query MyQuery {
        genericPersonalizedAdvisor(locale: ${currentLocale}) {
            ${CMS_SERVICE_HERO_QUERY}
          }
        }`
    try {
      const data = await datoHelperClient.request(query, 'genericPersonalizedAdvisor' + currentLocale)
      if (!data || (!data.genericPersonalizedAdvisor)) {
        return createError({
          statusCode: 404
        })
      }
      const results = data
      return results
    } catch (ex) {
      useCustomError(ex)
    }
  },
  data () {
    return {
      cta: this.$messages('services-personalized-advisors.hero.cta'),
      breadcrumbs: [
        {
          title: this.$messages('label.home'),
          to: this.$mRouter.getLocalRoute({ name: 'index' })
        },
        {
          title: this.$messages('page_labels.personal_advisor')
        }
      ]
    }
  },
  computed: {
    ogImage () {
      return optimize(
        'https://majority.imgix.net/web-assets/meta/og.png',
        false,
        { w: 1200, h: 630, fit: 'fill', fill: 'solid', 'fill-color': '283A35' }
      )
    },
    cmsData () {
      return this.genericPersonalizedAdvisor
    }
  },
  methods: {
    onCtaHeroClick () {
      this.$refs.checkout.$el.querySelector('#mini-checkout-form').scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
      this.$track.linkClicked('personalizedAdvisorsHeroButton', 'cta', { linkText: this.cta })
    }
  }

}
</script>
